export default "__VITE_ASSET__B7kXVJ7N__"